import { ClientEmployeeModel } from './client.employee.model';

export class ClientRegistrationModel {
    Model: ClientEmployeeModel;
    Password: string
  }
